export default (baseUrl: string) => {
    const objectToQueryString = (obj: any) =>
        Object.keys(obj)
            .map((key) => key + '=' + obj[key])
            .join('&');

    async function request(url: string, params: any, header: any, method = 'GET') {
        const headers = {
            ...header,
            // ...{ "Content-Type": "application/json" },
        };

        const options: RequestInit = { method, headers };

        if (params) {
            if (method === 'GET') {
                url += '?' + objectToQueryString(params);
            } else {
                options.body = JSON.stringify(params);
            }
        }

        const response = await fetch(baseUrl + url, options);

        const errMsgGen = (message: string) => ({
            status: 'error',
            message,
        });

        if (!response.ok) {
            return errMsgGen('The server responded with an unexpected status.');
        }

        return await response.json();
    }

    const get = (url: string, params?: any, header = {}) => request(url, params, header);
    const create = (url: string, params?: any, header = {}) => request(url, params, (header = {}), 'POST');
    const update = (url: string, params?: any, header = {}) => request(url, params, (header = {}), 'PUT');
    const remove = (url: string, params?: any, header = {}) => request(url, params, header, 'DELETE');

    return { get, create, update, remove };
};
